/**
 * Decodes a Base64URL string to a regular string
 * Based on jwt-decode library implementation
 */
function base64UrlDecode(str) {
  // Convert Base64URL to Base64 by replacing URL-safe characters
  let output = str.replace(/-/g, "+").replace(/_/g, "/");

  // Add proper padding
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("Illegal base64url string!");
  }

  try {
    // Decode with Unicode support
    return decodeURIComponent(
      atob(output).replace(/(.)/g, function (m, p) {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
          code = "0" + code;
        }
        return "%" + code;
      })
    );
  } catch (err) {
    // Fallback to basic atob if Unicode decoding fails
    return atob(output);
  }
}

/**
 * Decodes a JWT token and returns the payload
 * Based on jwt-decode library implementation
 */
export function jwtDecode(token, options = {}) {
  if (typeof token !== "string") {
    throw new Error("Invalid token specified: must be a string");
  }

  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("Invalid token specified: must have 3 parts");
  }

  // pos = 0 for header, pos = 1 for payload
  const pos = options.header === true ? 0 : 1;

  try {
    return JSON.parse(base64UrlDecode(parts[pos]));
  } catch (e) {
    throw new Error("Invalid token specified: " + e.message);
  }
}

/**
 * Checks if a JWT token is expired
 */
export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);

    // Check if exp claim exists
    if (!decoded.exp || typeof decoded.exp !== "number") {
      return true; // No expiration claim, consider expired
    }

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true; // Consider expired if we can't decode it
  }
}

/**
 * Gets the expiration time from a JWT token
 */
export function getTokenExpiration(token) {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp ? new Date(decoded.exp * 1000) : null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}
